const vi = {
  translation: {
    // ─── Common ────────────────────────────────────────────────────────
    common: {
      loading: 'Đang tải...',
      error: 'Lỗi',
      cancel: 'Hủy',
      confirm: 'Xác nhận',
      save: 'Lưu',
      delete: 'Xóa',
      done: 'Xong',
      back: 'Quay Lại',
      close: 'Đóng',
      retry: 'Thử lại',
      ok: 'OK',
      yes: 'Có',
      no: 'Không',
      or: 'hoặc',
      and: 'và',
      years: 'tuổi',
      noData: 'Không có dữ liệu',
      seeAll: 'Xem Tất Cả',
      logout: 'Đăng xuất',
      logoutConfirm: 'Bạn có chắc muốn đăng xuất?',
      continue: 'Tiếp Tục',
      month: 'Tháng',
      months: 'Tháng',
    },

    // ─── Tabs ──────────────────────────────────────────────────────────
    tabs: {
      home: 'TRANG CHỦ',
      classes: 'LỚP HỌC',
      training: 'TẬP LUYỆN',
      profile: 'CÁ NHÂN',
    },

    // ─── Auth ──────────────────────────────────────────────────────────
    auth: {
      welcomeBack: 'Chào Mừng Trở Lại',
      signInSubtitle: 'Đăng nhập vào tài khoản của bạn',
      appDescription: 'Quản lý hội viên CBJJ Saigon, lớp học và tiến độ đào tạo của bạn.',
      email: 'Email',
      password: 'Mật khẩu',
      signIn: 'Đăng Nhập',
      noAccount: 'Chưa có tài khoản?',
      register: 'Đăng Ký',
      createAccount: 'Tạo Tài Khoản',
      joinCbjj: 'Tham Gia CBJJ Saigon',
      firstName: 'Tên',
      lastName: 'Họ',
      iAmA: 'Tôi là:',
      alreadyHaveAccount: 'Đã có tài khoản?',
      signInLink: 'Đăng Nhập',
      // Roles
      roleAthlete: 'Vận động viên',
      roleGuardian: 'Phụ huynh',
      roleCoach: 'Huấn luyện viên',
      // Validation
      emailRequired: 'Vui lòng nhập email',
      passwordRequired: 'Vui lòng nhập mật khẩu',
      firstNameRequired: 'Vui lòng nhập tên',
      lastNameRequired: 'Vui lòng nhập họ',
      invalidNumber: 'Vui lòng nhập số hợp lệ',
      loginFailed: 'Đăng nhập thất bại',
      registrationFailed: 'Đăng ký thất bại',
      // Forgot / Reset password
      forgotPassword: 'Quên mật khẩu?',
      forgotPasswordSubtitle: 'Nhập email và chúng tôi sẽ gửi liên kết đặt lại mật khẩu',
      sendResetLink: 'Gửi Liên Kết',
      resetEmailSent: 'Kiểm Tra Email',
      resetEmailSentDetail: 'Chúng tôi đã gửi liên kết đặt lại mật khẩu đến email của bạn.',
      backToSignIn: 'Quay Lại Đăng Nhập',
      resetPassword: 'Đặt Lại Mật Khẩu',
      newPassword: 'Mật khẩu mới',
      confirmPassword: 'Xác nhận mật khẩu',
      passwordMinLength: 'Mật khẩu phải có ít nhất 8 ký tự',
      passwordMismatch: 'Mật khẩu không khớp',
      passwordResetSuccess: 'Mật khẩu đã được đặt lại thành công!',
      // Email verification
      verifyEmail: 'Xác Minh Email',
      verifyEmailSubtitle: 'Chúng tôi đã gửi mã xác minh đến {{email}}',
      verificationEmailSent: 'Đã gửi email xác minh!',
      verificationCode: 'Mã Xác Minh',
      verifyCode: 'Xác Minh',
      verificationCodeRequired: 'Vui lòng nhập mã xác minh',
      invalidVerificationCode: 'Mã xác minh không hợp lệ. Vui lòng thử lại.',
      tooManyRequests: 'Quá nhiều lần thử. Vui lòng thử lại sau.',
      verificationSendFailed: 'Không thể gửi email xác minh',
      syncFailed: 'Không thể đồng bộ tài khoản. Vui lòng thử lại.',
      goToVerification: 'Xác Minh Email',
      continueToApp: 'Tiếp Tục',
      resendVerification: 'Gửi Lại Email Xác Minh',
      resendIn: 'Gửi lại sau {{seconds}} giây',
      // Social login
      or: 'hoặc',
      continueWithGoogle: 'Tiếp tục với Google',
      continueWithApple: 'Tiếp tục với Apple',
      // Auth callback
      authenticating: 'Đang xác thực...',
      authenticationFailed: 'Xác Thực Thất Bại',
      callbackError: 'Đã xảy ra lỗi trong quá trình xác thực. Vui lòng thử lại.',
      callbackNoVerifier: 'Không nhận được dữ liệu xác thực. Vui lòng đăng nhập lại.',
      // Profile completion (new users / OAuth)
      completeYourProfile: 'Hoàn Tất Hồ Sơ',
      completeProfileSubtitle: 'Thêm một vài thông tin để bắt đầu.',
      dateOfBirth: 'Ngày sinh',
      birthdayRequired: 'Vui lòng nhập ngày sinh',
      dateOfBirthRequired: 'Vui lòng nhập ngày sinh',
      birthdayFormat: 'Dùng định dạng YYYY-MM-DD',
      birthdayInvalid: 'Vui lòng nhập ngày hợp lệ',
      selectDate: 'Chọn ngày',
      profileUpdateFailed: 'Cập nhật hồ sơ thất bại',
      // Terms
      termsPrefix: 'Tôi đồng ý với',
      privacyPolicy: 'Chính Sách Bảo Mật',
      termsAnd: 'và',
      termsOfService: 'Điều Khoản Dịch Vụ',
      termsRequired: 'Bạn phải chấp nhận Chính Sách Bảo Mật và Điều Khoản Dịch Vụ',
      ageRequirement: 'Bạn phải từ 18 tuổi trở lên để đăng ký làm người dùng chính',
    },

    // ─── Home Screen ───────────────────────────────────────────────────
    home: {
      checkIn: 'Điểm danh',
      scanAtDesk: 'Quét tại quầy lễ tân',
      idPrefix: 'Mã',
      nextClass: 'LỚP SẮP TỚI',
      today: 'HÔM NAY',
      coachTba: 'Huấn luyện viên TBA',
      coachPrefix: 'Huấn luyện viên {{name}}',
      mainMat: 'Thảm chính',
      noClassesToday: 'Không có lớp học hôm nay',
      pendingActivation: {
        title: 'Đang Chờ Kích Hoạt',
        body: 'Thanh toán của bạn đang được đội ngũ kiểm tra.\n\nCó thể mất đến 1 ngày làm việc để xác minh thanh toán.\n\nQR điểm danh sẽ khả dụng sau khi kích hoạt.',
      },
      membershipPaused: {
        title: 'Gói tập đã tạm dừng',
        body: 'Gói tập của bạn hiện đang tạm dừng.\n\nKhông thể điểm danh trong thời gian tạm dừng.',
      },
      timeRestriction: 'Gói tập giới hạn {{start}} - {{end}}',
      noClassesInAllowedHours: 'Không có lớp nào trong khung giờ cho phép của gói tập',
      dayRestrictionToday: 'Gói tập của bạn không cho phép học vào hôm nay',
      planNotValidToday: 'Gói tập của bạn không có hiệu lực cho các lớp học hôm nay',
    },

    // ─── Classes Screen ────────────────────────────────────────────────
    classes: {
      timetable: 'Lịch học',
      loadingClasses: 'Đang tải lớp học...',
      noClassesScheduled: 'Không có lớp nào được lên lịch',
      dayClosed: 'Đóng cửa hôm nay',
      dayClosedOther: 'Đóng cửa',
      dayClosedPublicHoliday: 'Đóng cửa hôm nay - Ngày lễ',
      closedPublicHoliday: 'Đóng cửa - Ngày lễ',
      closedBadge: 'Đóng cửa',
      publicHolidayBadge: 'Ngày lễ',
      timeChanged: 'Thay đổi giờ',
      timeRestriction: 'Gói tập cho phép {{start}} - {{end}}',
      outsidePlanHours: 'Ngoài giờ gói tập',
      dayNotAllowed: 'Gói tập của bạn không cho phép học vào ngày này',
      // Day abbreviations
      dayMon: 'T2',
      dayTue: 'T3',
      dayWed: 'T4',
      dayThu: 'T5',
      dayFri: 'T6',
      daySat: 'T7',
      daySun: 'CN',
    },

    // ─── Training Screen ───────────────────────────────────────────────
    training: {
      title: 'Theo Dõi Tập Luyện',
      currentRank: 'CẤP BẬC HIỆN TẠI',
      stripe_one: '{{count}} Vạch',
      stripe_other: '{{count}} Vạch',
      timeInBelt: 'Thời Gian Mang Đai',
      months: '{{count}} tháng',
      days: '{{count}} ngày',
      lastPromo: 'Lên Đai Gần Nhất',
      coachNotes: 'GHI CHÚ CỦA HLV',
      setRank: {
        title: 'Thiết lập đai hiện tại của bạn',
        subtitle: 'Cho chúng tôi biết đai và vạch của bạn để quá trình tập luyện bắt đầu đúng chỗ. Các lần lên đai sau sẽ do HLV ghi nhận.',
        belt: 'Đai',
        stripes: 'Vạch',
        promoDate: 'Lần lên đai gần nhất của bạn? (không bắt buộc)',
        submit: 'Lưu đai của tôi',
        note: 'Chỉ thiết lập được một lần — sau đó việc lên đai do HLV ghi nhận.',
        beltRequired: 'Vui lòng chọn đai của bạn',
        alreadySet: 'Đai của bạn đã được ghi nhận.',
      },
    },

    // ─── Profile Screen ────────────────────────────────────────────────
    profile: {
      guardian: 'Phụ huynh: {{name}}',
      guardianTag: 'Phụ huynh',
      age: 'Tuổi: {{count}}',
      dob: 'Ngày sinh',
      picture: {
        title: 'Ảnh Đại Diện',
        upload: 'Tải Ảnh Mới',
        remove: 'Xóa Ảnh',
      },
      membershipPayment: 'GÓI TẬP & THANH TOÁN',
      currentPlan: 'Gói hiện tại',
      noPlan: 'Chưa có gói',
      active: 'ĐANG HOẠT ĐỘNG',
      inactive: 'KHÔNG HOẠT ĐỘNG',
      nextPayment: 'Thanh toán tiếp theo',
      manageMembership: 'Quản lý gói tập',
      hideHistory: 'Ẩn lịch sử',
      paymentHistory: 'Lịch sử thanh toán',
      payment: 'Thanh toán',
      noPaymentHistory: 'Chưa có lịch sử thanh toán',
      familyMembers: 'THÀNH VIÊN GIA ĐÌNH',
      pendingActivation: {
        title: 'Đang Chờ Kích Hoạt',
        body: 'Thanh toán của bạn đang được đội ngũ kiểm tra.\n\nCó thể mất đến 1 ngày làm việc để xác minh thanh toán.',
      },
      belt: 'Đai {{name}}',
      viewing: 'Đang xem',
      lightMode: 'Chế độ sáng',
      darkMode: 'Chế độ tối',
      language: 'Ngôn ngữ',
      appSettings: 'Thông tin ứng dụng',
      personal: {
        edit: 'Chỉnh sửa thông tin cá nhân',
        title: 'Thông Tin Cá Nhân',
        firstName: 'Tên',
        lastName: 'Họ',
        birthday: 'Ngày sinh',
        save: 'Lưu',
        nameRequired: 'Vui lòng nhập họ và tên',
      },
      signOut: 'Đăng xuất',
      signingOut: 'Đang đăng xuất...',
      noFamilyMembers: 'Chưa liên kết thành viên gia đình nào',
      addFamilyMember: 'Thêm thành viên gia đình',
      invite: {
        title: 'Mời vào ứng dụng',
        editTitle: 'Cập nhật email đăng nhập',
        edit: 'Chỉnh sửa lời mời',
        invite: 'Mời vào ứng dụng',
        registered: 'Đã đăng ký',
        help: 'Chia sẻ mã QR hoặc liên kết này với {{name}} để họ có thể đăng ký tài khoản của riêng mình.',
        linkLabel: 'Liên kết mời',
        copy: 'Sao chép liên kết',
        copied: 'Đã sao chép liên kết',
        expires: 'Hết hạn vào {{date}}',
        regenerate: 'Tạo liên kết mới',
        failed: 'Không thể tạo lời mời',
        welcome: 'Bạn Được Mời!',
        invitedBy: 'Được mời bởi {{guardian}}',
        athleteName: 'Tên',
        invalid: 'Lời mời không hợp lệ',
        notFound: 'Liên kết lời mời này không hợp lệ hoặc đã hết hạn.',
      },
      managedBy: 'Được quản lý bởi {{name}}',
      managedByFamily: 'Được quản lý bởi gia đình của bạn',
      managedByGuardian: 'Tài khoản này được quản lý bởi {{guardian}}.',
      started: 'Đã bắt đầu {{date}}',
      ends: 'Kết thúc {{date}}',
      membership: {
        title: 'Thành viên',
        plan: 'Gói',
        status: 'Trạng thái',
        expires: 'Hết hạn',
        renew: 'Gia hạn thành viên',
        noMembership: 'Không có thành viên hoạt động',
        upgrade: 'Nâng cấp gói',
        downgrade: 'Hạ cấp gói',
      },
      logout: 'Đăng xuất',
      logoutConfirm: 'Bạn có chắc chắn muốn đăng xuất?',
      cancel: 'Hủy',
      confirm: 'Xác nhận',
      appName: 'Tên Ứng Dụng',
      version: 'Phiên Bản',
      build: 'Build',
      platform: 'Nền Tảng',
      bundleId: 'Bundle ID',
      channel: 'Kênh',
      updateId: 'ID Cập Nhật',
      unknown: 'Không rõ',
      pausedUntil: 'Tạm dừng đến {{date}}',
      pausedIndefinite: 'Tạm dừng không thời hạn',
      bodyMeasurements: 'Số đo',
      bodyMeasurementsHint: 'Tùy chọn — dùng để xác định size kimono của hội viên',
      weight: 'Cân nặng',
      height: 'Chiều cao',
      metric: 'Mét',
      imperial: 'Anh',
    },

    // ─── Membership Paused Banner ──────────────────────────────────────
    pausedBanner: {
      title: 'Gói tập đã tạm dừng',
      until: 'Đến {{date}}',
      indefinite: 'Tạm dừng không thời hạn',
      reason: 'Lý do: {{reason}}',
    },

    // ─── App Header ────────────────────────────────────────────────────
    header: {
      athlete: 'Vận động viên',
      switchRole: 'CHUYỂN VAI TRÒ',
      viewingAs: 'XEM VỚI TƯ CÁCH',
      selfSuffix: '(Tôi)',
    },

    // ─── Billing Screen ────────────────────────────────────────────────
    billing: {
      membershipPricing: 'Gói Tập & Bảng Giá',
      checkout: 'Thanh Toán',
      choosePlan: '1. Chọn gói',
      checkoutStep: '2. Thanh toán',
      heroTitle: 'Gói Tập',
      heroPricing: '& Bảng Giá.',
      heroSubtitle: 'Huấn luyện Jiu-Jitsu đẳng cấp thế giới. Chọn gói phù hợp với hành trình của bạn.',
      selectPlan: 'Chọn Gói',
      perMonth: '/ tháng',
      currency: 'VND',
      targetedOfferBadge: 'Ưu Đãi Riêng',
      // Community Grant
      communityGrant: 'Hỗ Trợ Cộng Đồng',
      communityGrantIndex: '06',
      communityGrantPrice: 'Giảm đến 45%',
      communityGrantNote: 'THEO ĐĂNG KÝ',
      communityGrantDesc: 'Hỗ trợ vận động viên địa phương, sinh viên và thanh thiếu niên. Đào tạo chất lượng cao với chi phí hợp lý.',
      applyNow: 'Đăng Ký Ngay',
      communityGrantAlert: 'Đang chuyển đến trang đăng ký...',
      // Order Summary
      orderSummary: 'TÓM TẮT ĐƠN HÀNG',
      monthlySubscription: 'Đăng ký hàng tháng',
      subtotal: 'Tạm tính',
      platformFees: 'Phí nền tảng',
      calculatedNext: 'Tính vào kỳ tiếp theo',
      totalDueToday: 'Tổng thanh toán hôm nay',
      // Payment Methods
      paymentMethod: 'Phương thức thanh toán',
      localBank: 'Ngân hàng nội địa / VietQR',
      localBankFees: '0% Phí · Thanh toán qua Ứng dụng',
      internationalCard: 'Thẻ quốc tế',
      internationalCardSub: 'Visa, MasterCard, Amex',
      savedCards: 'THẺ ĐÃ LƯU',
      recurringTokenized: 'Định kỳ · Token hóa',
      tokenBadge: 'Thẻ lưu',
      // OnePay (disabled)
      onepayPayment: 'Thanh toán qua thẻ OnePay',
      onepayDisabled: 'Thanh toán thẻ tín dụng sắp có',
      onepayCard: 'Thanh toán bằng thẻ',
      payWithCard: 'Visa, MasterCard, JCB',
      useSavedCard: 'Sử dụng thẻ đã lưu',
      // 9Pay Panel
      securedBy9Pay: 'Bảo mật bởi 9Pay',
      scanViaBanking: 'Quét Qua Ứng Dụng Ngân Hàng',
      scanViaBankingDesc: 'Mở ứng dụng ngân hàng hoặc ví điện tử để quét mã này. Số tiền đã được điền sẵn.',
      noAutoDeduct: 'Không Trừ Tiền Tự Động.',
      noAutoDeductDesc: 'Bạn sẽ nhận link 9Pay mới mỗi chu kỳ thanh toán qua Zalo & Email.',
      // Card Panel
      cardDetails: 'Thông Tin Thẻ',
      savedCardTokenized: 'Thẻ Đã Lưu · Mã hóa qua OnePay',
      secureRedirect: 'Chuyển Hướng An Toàn',
      secureRedirectDesc: 'Bạn sẽ được chuyển hướng an toàn đến trang thanh toán OnePay để nhập thông tin thẻ. Chúng tôi không bao giờ nhìn thấy số thẻ đầy đủ của bạn.',
      saveCardLabel: 'Lưu thẻ cho chu kỳ thanh toán tiếp theo',
      saveCardDesc: 'Thẻ của bạn được xử lý an toàn và token hóa qua OnePay. Chúng tôi không lưu trữ số thẻ thực.',
      processing: 'Đang xử lý...',
      payAmount: 'Thanh toán {{amount}}',
      // Footer
      vatCompliant: 'Tuân thủ VAT & Hóa Đơn Điện Tử',
      // Errors
      errorOpenPayment: 'Không thể mở trang thanh toán',
      paymentError: 'Lỗi thanh toán',
      saveAmount: 'Tiết kiệm {{amount}} / {{count}} tháng',
      discountPercent: 'Giảm {{percent}}%',
      discountFreeMonths: 'Miễn phí {{count}} tháng',
      discountFreeMonths_other: 'Miễn phí {{count}} tháng',
    },

    // ─── Payment Result Screen ─────────────────────────────────────────
    paymentResult: {
      waitingTitle: 'Đang Chờ Thanh Toán',
      waitingSubtitle: 'Hoàn tất thanh toán trên trang OnePay.\nMàn hình này sẽ tự động cập nhật.',
      successTitle: 'Thanh Toán Thành Công',
      successSubtitle: 'Gói tập của bạn đã được kích hoạt.',
      cardSaved: 'Thẻ đã được lưu cho lần thanh toán sau',
      failedTitle: 'Thanh Toán Thất Bại',
      failedSubtitle: 'Thanh toán chưa được hoàn tất. Vui lòng thử lại.',
      timeoutTitle: 'Hết Thời Gian Chờ',
      timeoutSubtitle: 'Chúng tôi chưa nhận được xác nhận từ OnePay. Nếu bạn đã thanh toán, giao dịch có thể vẫn đang được xử lý.',
      plan: 'Gói tập',
      amount: 'Số tiền',
      status: 'Trạng thái',
      statusPending: 'Đang chờ',
      statusCompleted: 'Hoàn tất',
      statusFailed: 'Thất bại',
      statusTimeout: 'Hết Thời Gian',
      tryAgain: 'Thử Lại',
      backToHome: 'Về Trang Chủ',
      cancelGoBack: 'Hủy & Quay Lại',
    },

    // ─── VietQR Screen ────────────────────────────────────────────────
    vietqr: {
      awaitingTitle: 'Hoàn Tất Thanh Toán',
      awaitingSubtitle: 'Quét mã QR bằng ứng dụng ngân hàng để thanh toán. Sau khi hoàn tất, nhấn "Tôi đã hoàn tất thanh toán".',
      confirmedTitle: 'Đã Gửi Xác Nhận',
      confirmedSubtitle: 'Chúng tôi đã nhận được xác nhận của bạn.\n\nCó thể mất đến 1 ngày làm việc để đội ngũ xác minh thanh toán.\n\nBạn sẽ nhận được biên lai thanh toán qua email sau khi được xác nhận.',
      confirmedContinueNote: 'Bạn có thể tiếp tục vào ứng dụng trong khi chờ xác nhận thanh toán cuối cùng.',
      successTitle: 'Thanh Toán Thành Công',
      successSubtitle: 'Gói tập của bạn đã được kích hoạt. Chào mừng đến CBJJ!',
      failedTitle: 'Thanh Toán Thất Bại',
      failedSubtitle: 'Thanh toán chưa được hoàn tất. Vui lòng thử lại.',
      scanToPay: 'Quét để Thanh Toán',
      accountName: 'Tên Tài Khoản',
      accountNumber: 'Số Tài Khoản',
      bankBin: 'Ngân Hàng (BIN)',
      orderNumber: 'Mã Đơn Hàng',
      amount: 'Số tiền',
      orderDetails: 'Chi tiết đơn hàng',
      membershipOrder: 'Đơn hàng gói tập',
      subtotal: 'Tạm tính',
      discounts: 'Giảm giá',
      total: 'Tổng cộng',
      status: 'Trạng thái',
      statusPending: 'Đang chờ',
      statusCompleted: 'Hoàn tất',
      statusFailed: 'Thất bại',
      statusAwaitingVerification: 'Đang chờ xác minh',
      tryAgain: 'Thử Lại',
      markPaidBtn: 'Tôi đã hoàn tất thanh toán',
      markingPaid: 'Đang xác nhận...',
      continueToApp: 'Tiếp tục vào ứng dụng',
      viewConfirmation: 'Xem Trạng Thái Xác Nhận',
      backToPaymentInstructions: 'Xem Mã QR & Chi Tiết Chuyển Khoản',
      cancelPayment: 'Hủy Thanh Toán',
      cancelConfirmTitle: 'Hủy Thanh Toán?',
      cancelConfirmDesc: 'Bạn có chắc muốn hủy thanh toán này? Hóa đơn và mã QR sẽ bị vô hiệu hóa vĩnh viễn, và bạn sẽ cần bắt đầu lại quy trình thanh toán.',
      cancelConfirmBtn: 'Có, Hủy Thanh Toán',
      keepPaymentBtn: 'Không, Giữ Thanh Toán',
      saveQrCode: 'Lưu Mã QR',
      securedByVietQR: 'Bảo mật bởi VietQR',
      pushPaymentTitle: 'Thanh Toán VietQR',
      pushPaymentSubtitle: 'Quét mã QR bằng ứng dụng ngân hàng Việt Nam. Số tiền chính xác và mã hóa đơn được tự động điền.',
      noAutoDeduct: 'Không Tự Động Trừ',
      noAutoDeductDesc: 'Đây là thanh toán thủ công. Bạn sẽ tự thực hiện chuyển khoản từ ứng dụng ngân hàng mỗi kỳ thanh toán.',
      mediaPermissionRequired: 'Cần quyền truy cập ảnh để lưu mã QR.',
      qrSavedSuccess: 'Đã lưu mã QR vào thư viện ảnh!',
      qrSavedFailed: 'Không thể lưu mã QR. Vui lòng chụp màn hình thay thế.',
    },

    // ─── Pending Verification Banner ───────────────────────────────────
    pendingBanner: {
      title: 'Thanh toán đang chờ xác minh',
      listening: 'Đang lắng nghe...',
      checkNow: 'Kiểm tra',
    },

    // ─── Activation Success Banner ──────────────────────────────────────
    activationSuccess: {
      title: 'Tài khoản của bạn đã được kích hoạt thành công!',
    },

    // ─── Subscription Screen (forced onboarding) ──────────────────────
    subscription: {
      choosePlan: 'Chọn Gói Tập',
      heroTitle: 'Chọn Gói Tập',
      heroSubtitle: 'Chọn gói tập để bắt đầu với CBJJ.',
      choosePlanSubtitle: 'Chọn gói tập phù hợp với mục tiêu tập luyện của bạn. Bạn có thể thêm thành viên gia đình khi thanh toán.',
      duration: 'Chu kỳ thanh toán',
      plans: 'Gói tập',
      vietqrPush: 'Thanh Toán VietQR',
      vietqrPushSub: '0% Phí · Thanh toán qua App Ngân Hàng',
      addMembers: 'Thêm Thành Viên',
      addMembersTitle: 'Chọn Gói Cho Gia Đình',
      addMembersSubtitle: 'Thêm thành viên gia đình cần gói tập. Một khoản thanh toán cho tất cả.',
      addFamilyMember: 'THÊM THÀNH VIÊN GIA ĐÌNH',
      addMember: 'Thêm Thành Viên',
      addFamilyMembers: 'THÊM THÀNH VIÊN GIA ĐÌNH',
      add: 'Thêm',
      addFamilyHint: 'Nhấn + Thêm để thêm thành viên gia đình (trẻ em hoặc người phụ thuộc) và chọn gói tập cho họ.',
      familyMembers: 'Thành viên gia đình',
      familyMembersSubtitle: 'Chọn gói tập cho từng thành viên gia đình.',
      selectPlansForMembers: 'CHỌN GÓI CHO TỪNG THÀNH VIÊN',
      selectMembershipToProceed: 'Chọn gói tập cho bạn hoặc thành viên gia đình để tiếp tục',
      selectPlan: 'Chọn Gói →',
      skipPlanTitle: 'Bỏ Qua Hiện Tại',
      skipPlanDesc: 'Hoàn hảo nếu bạn chỉ muốn thêm thành viên gia đình ngay bây giờ. Bạn có thể đăng ký cho chính mình bất cứ lúc nào từ hồ sơ của mình.',
      addFamily: 'Thêm Gia Đình',
      addAnotherMember: 'Thêm Người Khác',
      familyPromptTitle: 'Thêm thành viên gia đình?',
      familyPromptSubtitle: 'Bạn có con hoặc người phụ thuộc cần gói tập không? Một lần thanh toán cho tất cả.',
      familyPromptYes: 'Có, Thêm Gia Đình',
      familyPromptNo: 'Không, Chỉ Mình Tôi',
      selectPlanForMember: 'Chọn gói tập cho {{name}}',
    },

    // ─── Referral System ─────────────────────────────────────────────
    referral: {
      title: 'Giới Thiệu Bạn Bè',
      subtitle: 'Giới thiệu bạn bè, mọi người đều nhận tháng miễn phí',
      howItWorks: 'Chia sẻ mã của bạn với bạn bè. Khi họ tham gia và duy trì hoạt động trong 6 tháng, họ sẽ nhận +1 tháng miễn phí (đảm bảo). Bạn nhận +1 tháng miễn phí cho mỗi người bạn còn hoạt động sau 6 tháng.',
      yourCode: 'Mã giới thiệu của bạn',
      copy: 'Sao chép',
      copied: 'Đã sao chép!',
      share: 'Chia sẻ',
      shareMessage: 'Tham gia CBJJ Saigon cùng tôi! Sử dụng mã giới thiệu {{code}} và cả hai chúng ta đều nhận được một tháng miễn phí sau 6 tháng. https://cbjj.app',
      refereeTitle: 'Bạn Đã Sử Dụng Mã Giới Thiệu',
      redemptionsTitle: 'Giới Thiệu Của Bạn',
      stats: {
        signups: 'Người tham gia',
        rewards: 'Phần thưởng',
        pending: 'Đang chờ',
      },
      rewardStatus: {
        awarded: 'Đã thưởng',
        pending: 'Đang chờ',
        skipped: 'Không đủ điều kiện',
      },
      redeemedOn: 'Tham gia {{date}}',
      rewardDue: 'Thưởng vào {{date}}',
      status: {
        unused: 'Mã của bạn đã sẵn sàng — hãy chia sẻ với bạn bè!',
        pending: '{{name}} đã tham gia vào {{date}}. Bạn sẽ nhận +1 tháng miễn phí vào {{rewardDate}} nếu gói tập vẫn còn hoạt động.',
        rewardAwarded: '+1 tháng miễn phí đã được thêm vào {{date}}. Cảm ơn bạn đã chia sẻ!',
        rewardForfeited: 'Phần thưởng không thể áp dụng — gói tập không còn hoạt động.',
        refereePending: 'Bạn đã sử dụng mã của {{name}} vào {{date}}. Bạn sẽ nhận +1 tháng miễn phí vào {{rewardDate}} nếu gói tập vẫn còn hoạt động.',
        refereeAwarded: 'Bạn đã nhận +1 tháng miễn phí từ {{name}} vào {{date}}.',
        refereeForfeited: 'Phần thưởng giới thiệu của bạn không thể áp dụng — gói tập không còn hoạt động.',
        codeRevoked: 'Mã giới thiệu này đã bị thu hồi và không thể sử dụng.',
      },
      checkoutPrompt: 'Có mã giới thiệu?',
      apply: 'Áp dụng',
      applied: 'Đã áp dụng mã giới thiệu',
      remove: 'Xóa',
      rewardChip: '+1 tháng miễn phí sau tháng thứ 6',
      appliedSuccess: '✓ Đã áp dụng mã giới thiệu. Bạn và {{name}} sẽ mỗi người nhận +1 tháng miễn phí sau 6 tháng hoạt động.',
      invalidCode: 'Mã giới thiệu không hợp lệ',
      unappliedCodeTitle: 'Áp dụng mã giới thiệu?',
      unappliedCodeMessage: 'Bạn đã nhập mã giới thiệu nhưng chưa áp dụng. Nhấn "Áp dụng" để sử dụng, hoặc xóa trường để tiếp tục không dùng mã.',
      membershipNote: {
        pending: 'Thưởng giới thiệu đang chờ — +1 tháng miễn phí sẽ được áp dụng vào {{date}}',
        awarded: 'Thưởng giới thiệu đã áp dụng — +1 tháng miễn phí được thêm vào {{date}}',
        forfeited: 'Không thể áp dụng thưởng giới thiệu',
      },
    },

    // ─── Belt names ────────────────────────────────────────────────────
    belts: {
      white: 'Trắng',
      grey: 'Xám',
      yellow: 'Vàng',
      orange: 'Cam',
      green: 'Xanh lá',
      blue: 'Xanh dương',
      purple: 'Tím',
      brown: 'Nâu',
      black: 'Đen',
    },

    // ─── Skill Requirements (i18n-only, no DB) ────────────────────────
    skillRequirements: {
      white: {
        shrimp_hip_escape: {
          name: 'Tôm/Trượt Hông',
          description: 'Kỹ thuật di chuyển hông cơ bản và thoát thế',
        },
        bridge_roll_escape: {
          name: 'Bridge và Roll Escape',
          description: 'Thoát thế từ vị trí nằm trên (mount)',
        },
        closed_guard_maintenance: {
          name: 'Giữ Closed Guard',
          description: 'Duy trì vị trí closed guard',
        },
        armbar_from_guard: {
          name: 'Armbar từ Guard',
          description: 'Khóa tay cơ bản từ closed guard',
        },
        rear_naked_choke: {
          name: 'Rear Naked Choke',
          description: 'Siết cổ cơ bản từ vị trí phía sau',
        },
      },
      grey: {
        guard_passing_basics: {
          name: 'Cơ Bản Vượt Guard',
          description: 'Kỹ thuật vượt guard cơ bản',
        },
        triangle_choke_setup: {
          name: 'Thiết Lập Triangle Choke',
          description: 'Siết tam giác từ guard',
        },
        kimura_from_guard: {
          name: 'Kimura từ Guard',
          description: 'Khóa Kimura từ closed guard',
        },
        side_control_escapes: {
          name: 'Thoát Side Control',
          description: 'Thoát thế từ side control',
        },
        basic_takedowns: {
          name: 'Takedowns Cơ Bản',
          description: 'Takedowns chân đơn và chân đôi',
        },
      },
      yellow: {},
      orange: {},
      green: {},
      blue: {},
      purple: {},
      brown: {},
      black: {},
    },

    // ─── Pickup Persons ───────────────────────────────────────────────
    pickup: {
      title: 'Người Đón & Liên Hệ Khẩn Cấp',
      sectionLabel: 'NGƯỜI ĐÓN & KHẨN CẤP',
      subtitle: 'Những người được phép đón con bạn và người liên hệ trong trường hợp khẩn cấp.',
      manage: 'Người được phép đón ({{count}})',
      empty: 'Chưa có người đón nào. Thêm người có thể đón con bạn.',
      add: 'Thêm người đón',
      addPerson: 'Thêm Người Đón',
      editPerson: 'Chỉnh Sửa Người Đón',
      name: 'Họ và tên',
      phone: 'Số điện thoại',
      relationship: 'Quan hệ (ví dụ: Cô)',
      relationshipPlaceholder: 'ví dụ: Cô, Chú, Bà',
      emergencyName: 'Tên liên hệ khẩn cấp',
      emergencyPhone: 'Điện thoại liên hệ khẩn cấp',
      emergency: 'Khẩn cấp',
      addPhoto: 'Thêm ảnh',
      delete: 'Xóa',
      deleteConfirm: 'Xóa người đón này?',
      deleteConfirmMessage: 'Hành động này không thể hoàn tác. Bạn có chắc muốn xóa người đón này?',
      photoUploadError: 'Không thể tải lên ảnh',
      requiredFields: 'Tên và số điện thoại là bắt buộc',
      nameRequired: 'Họ và tên là bắt buộc',
      phoneRequired: 'Số điện thoại là bắt buộc',
      fieldRequired: 'Trường này là bắt buộc',
      photoRequired: 'Ảnh là bắt buộc',
      accessDenied: 'Truy Cập Bị Từ Chối',
      promptTitle: 'Ai có thể đón con bạn?',
      promptBody: 'Thiết lập người được phép đón và liên hệ khẩn cấp để nhân viên của chúng tôi biết ai có thể đón con bạn.',
      promptCta: 'Thiết lập ngay',
      promptLater: 'Để sau',
    },

    // ─── Errors ────────────────────────────────────────────────────────
    errors: {
      user_not_found_or_inactive: 'Không tìm thấy người dùng hoặc tài khoản đã bị vô hiệu hóa',
      insufficient_permissions: 'Không đủ quyền hạn',
      role_not_authorized: 'Vai trò không được phép',
      not_authorized_athlete: 'Không được phép truy cập vận động viên này',
      class_not_found: 'Không tìm thấy lớp học',
      location_not_found: 'Không tìm thấy địa điểm',
      assignment_not_found: 'Không tìm thấy phân công',
      assignment_already_exists: 'Phân công đã tồn tại',
      family_link_already_exists: 'Liên kết gia đình đã tồn tại',
      not_authorized: 'Không được phép',
      link_not_found: 'Không tìm thấy liên kết',
      user_not_found: 'Không tìm thấy người dùng',
      email_already_registered: 'Email đã được đăng ký',
      email_already_in_use: 'Email này đã được sử dụng bởi tài khoản khác',
      sub_user_already_active: 'Thành viên gia đình này đã kích hoạt tài khoản',
      invalid_credentials: 'Thông tin đăng nhập không đúng',
      invalid_qr_payload: 'Mã QR không hợp lệ',
      invalid_target_scheme: 'Giao thức URL đích không hợp lệ cho proxy callback xác thực',
      qr_code_already_used: 'Mã QR đã được sử dụng',
      card_token_not_found: 'Không tìm thấy token thẻ',
      card_token_not_found_or_inactive: 'Không tìm thấy token thẻ hoặc đã bị vô hiệu hóa',
      membership_not_found: 'Không tìm thấy gói tập',
      missing_transaction_ref: 'Thiếu mã giao dịch',
      invalid_secure_hash: 'Mã bảo mật không hợp lệ — có thể bị giả mạo',
      payment_record_not_found: 'Không tìm thấy bản ghi thanh toán',
      no_bank_account_configured: 'Chưa cấu hình tài khoản ngân hàng cho thanh toán VietQR',
      not_a_vietqr_payment: 'Đây không phải là thanh toán VietQR',
      payment_already_completed: 'Thanh toán đã hoàn tất',
      payment_not_pending: 'Thanh toán không ở trạng thái chờ xử lý',
      payment_expired: 'Thanh toán đã hết hạn',
      admin_only: 'Hành động này chỉ dành cho quản trị viên',
      internal_server_error: 'Lỗi máy chủ nội bộ',
      auto_logged_qr: 'Tự động ghi nhận từ QR điểm danh',
      kids_plan_age_restriction: 'Gói thiếu nhi chỉ dành cho độ tuổi 5-15',
      adult_plan_age_restriction: 'Gói người lớn không dành cho độ tuổi 5-15',
      cannot_delete_plan_with_subscribers: 'Không thể xóa gói tập có hội viên. Hãy vô hiệu hóa thay thế.',
      cannot_delete_plan_with_members: 'Không thể xóa gói tập có hội viên. Hãy vô hiệu hóa thay thế.',
      cannot_subscribe_to_archived_plan: 'Không thể đăng ký gói tập không hoạt động.',
      cannot_subscribe_to_inactive_plan: 'Không thể đăng ký gói tập không hoạt động.',
      membership_plan_not_found: 'Không tìm thấy gói tập',
      cannot_delete_last_active_bank_account: 'Không thể xóa tài khoản ngân hàng hoạt động cuối cùng. Vui lòng tạo tài khoản khác trước.',
      cannot_pause_inactive_membership: 'Chỉ có thể tạm dừng gói tập đang hoạt động',
      membership_already_paused: 'Gói tập đã được tạm dừng',
      pause_start_date_in_past: 'Ngày bắt đầu tạm dừng không thể trong quá khứ',
      pause_end_date_before_start: 'Ngày kết thúc tạm dừng phải sau ngày bắt đầu',
      pause_end_date_exceeds_membership: 'Ngày kết thúc tạm dừng không thể vượt quá ngày hết hạn gói tập',
      membership_not_paused: 'Gói tập không đang tạm dừng',
      no_active_pause_found: 'Không tìm thấy tạm dừng đang hoạt động',
      membership_time_restricted: 'Không thể điểm danh: gói tập của bạn chỉ cho phép trong khung giờ nhất định',
      membership_day_restricted: 'Không thể điểm danh: gói tập của bạn không có hiệu lực cho các lớp học hôm nay',
      admin_user_not_found: 'Không tìm thấy tài khoản quản trị',
      pickup_person_not_found: 'Không tìm thấy người đón',
      field_required: 'Trường này là bắt buộc',
      referral: {
        code_not_found: 'Không tìm thấy mã giới thiệu',
        already_used: 'Mã giới thiệu này đã được sử dụng',
        already_redeemed: 'Bạn đã sử dụng mã giới thiệu này rồi',
        self_redeem: 'Bạn không thể sử dụng mã giới thiệu của chính mình',
        same_family: 'Bạn không thể sử dụng mã giới thiệu từ người trong gia đình',
        not_eligible_existing_member: 'Chỉ thành viên mới có thể sử dụng mã giới thiệu',
        code_revoked: 'Mã giới thiệu này đã bị thu hồi và không còn hiệu lực',
        referrer_not_active: 'Mã giới thiệu này từ thành viên không còn hoạt động. Chỉ thành viên đang hoạt động mới có thể giới thiệu người dùng mới.',
        generation_failed: 'Không thể tạo mã giới thiệu. Vui lòng thử lại.',
        unknown: 'Đã xảy ra lỗi với mã giới thiệu',
      },
      legal_name_mismatch: 'Tên bạn nhập không khớp với tên tài khoản.',
      legal_scroll_required: 'Bạn phải cuộn đến cuối tài liệu.',
      legal_affirmations_required: 'Bạn phải chấp nhận tất cả các khẳng định bắt buộc.',
      legal_sub_user_cannot_sign: 'Tài khoản được quản lý không thể ký tài liệu pháp lý trực tiếp.',
      legal_doc_not_found: 'Không tìm thấy tài liệu.',
      guardian_waiver_required: 'Cần có từ bỏ trách nhiệm người giám hộ để truy cập tài khoản.',
    },

    // ─── Membership Management Screen ────────────────────────────────────
    mgmt: {
      title: 'Quản Lý Gói Tập',
      membershipsTab: 'Gói Tập',
      addMemberTab: 'Thêm Thành Viên',
      paymentsTab: 'Thanh Toán',
      started: 'Bắt đầu {{date}}',
      startDate: 'Ngày Bắt Đầu',
      ended: 'Kết thúc {{date}}',
      ends: 'Kết thúc {{date}}',
      renew: 'Gia Hạn',
      renewEarly: 'Gia hạn sớm',
      addToPayment: 'Thêm vào thanh toán',
      queuedForPayment: 'Đã thêm vào thanh toán',
      renewalsSection: 'Gia hạn',
      totalEstimateHint: 'Số tiền cuối cùng được xác nhận ở màn hình thanh toán',
      renewalsDropped: 'Một số gia hạn đã bị xóa vì không còn hợp lệ. Vui lòng kiểm tra và thử lại.',
      payNow: 'Thanh Toán',
      addPlan: 'Thêm Gói',
      selectPlan: 'Chọn Gói',
      selectNewPlan: 'Chọn Gói Mới',
      addMember: 'Thêm Thành Viên',
      addMemberStep1: 'Nhập Thông Tin Thành Viên',
      addMemberPromptTitle: 'Thêm Thành Viên Gia Đình',
      addMemberPromptDesc: 'Thêm con hoặc người phụ thuộc và chọn gói cho họ.',
      addAndPay: 'Thêm & Thanh Toán',
      noMemberships: 'Chưa Có Gói Tập',
      noMembershipsDesc: 'Thêm thành viên gia đình hoặc chọn gói tập để bắt đầu.',

      // Đổi / huỷ gói
      changePlan: 'Đổi Gói',
      cancelMembership: 'Huỷ Gói Tập',
      contactForChangesTitle: 'Liên Hệ Chúng Tôi',
      contactForChangesMessage: 'Để đổi hoặc huỷ gói tập, vui lòng liên hệ trực tiếp với chúng tôi.',
      confirmCancelMembership: 'Xác Nhận Huỷ',
      cancelMembershipTitle: 'Huỷ Gói Tập?',
      cancelMembershipMessage: 'Gói hiện tại vẫn có hiệu lực đến hết kỳ. Bạn sẽ không bị tính phí thêm, và quyền truy cập kết thúc khi hết kỳ.',
      changeScheduledTitle: 'Đã Đặt Lịch Đổi Gói',
      changeScheduledMessage: 'Gói hiện tại vẫn có hiệu lực đến hết kỳ. Gói mới sẽ áp dụng khi kỳ kết thúc.',
      changeProratedHint: 'Nâng cấp được tính phí theo tỷ lệ cho phần còn lại của kỳ hiện tại.',
      payProrated: 'Thanh Toán Phần Chênh Lệch',
      scheduleChange: 'Đặt Lịch Đổi',
      upgrade: 'Nâng cấp',
      downgrade: 'Hạ cấp (theo lịch)',
      pendingChange: 'Thay đổi chờ xử lý',
      newMember: 'Thành Viên Mới',
      addToQueue: 'Thêm Vào Tóm Tắt',
      pendingChangesTitle: 'Xem Lại Thay Đổi',
      pendingChangesSubtitle: 'Xác nhận để thanh toán phí nâng cấp theo tỷ lệ. Hạ cấp sẽ có hiệu lực khi hết kỳ, không tính phí.',
      planTransition: '{{from}} → {{to}}',
      proratedAmount: 'Chênh lệch: {{amount}}',
      totalProrated: 'Tổng Chênh Lệch Phải Trả',
      noUpgradesScheduled: 'Không tính phí — tất cả thay đổi được đặt lịch cho cuối kỳ.',
      reviewAndPay: 'Xem Lại & Thanh Toán',
      confirmChanges: 'Xác Nhận Thay Đổi',
      remove: 'Bỏ',
      scheduledAppliedTitle: 'Đã Đặt Lịch Thay Đổi',
      scheduledAppliedMessage: 'Thay đổi cuối kỳ đã được đặt lịch. Không tính phí.',

      // Thanh báo đã lên lịch
      scheduledChangeTitle: 'Sẽ chuyển sang {{plan}} khi hết kỳ',
      scheduledCancelTitle: 'Đã đặt lịch huỷ',
      scheduledEndOfTerm: 'Gói hiện tại vẫn có hiệu lực đến hết kỳ.',
      undo: 'Hoàn Tác',
    },

    // ─── Membership status ─────────────────────────────────────────────
    membershipStatus: {
      active: 'Hoạt động',
      expired: 'Hết hạn',
      cancelled: 'Đã hủy',
      paused: 'Tạm dừng',
    },

    // ─── Payment status ────────────────────────────────────────────────
    paymentStatus: {
      pending: 'Đang chờ',
      completed: 'Hoàn tất',
      failed: 'Thất bại',
      refunded: 'Đã hoàn tiền',
    },

    // ─── Billing cycle ─────────────────────────────────────────────────
    billingCycle: {
      monthly: 'Hàng tháng',
      quarterly: 'Hàng quý',
      annual: 'Hàng năm',
    },

    // ─── Legal ─────────────────────────────────────────────────────────
    legal: {
      gateTitle: 'Thỏa Thuận Pháp Lý',
      disclaimer: 'Vui lòng xem xét và ký các tài liệu cần thiết để sử dụng ứng dụng và điểm danh/tham gia các lớp học.',
      progressLabel: 'Còn {{count}} tài liệu',
      scrollHint: 'Đọc đến cuối để tiếp tục',
      loadingDocument: 'Đang tải tài liệu...',
      scrollToEndToEnable: 'Vui lòng đọc đến cuối tài liệu để bật các hộp kiểm bên dưới.',
      signingFormTitle: 'Biểu mẫu ký',
      signedTitle: 'Đã ký ✓',
      loadingNextDoc: 'Đang tải tài liệu tiếp theo…',
      expandForm: 'Mở rộng biểu mẫu',
      collapseForm: 'Thu gọn biểu mẫu',
      signerNameLabel: 'Nhập họ tên pháp lý đầy đủ',
      agreeAndSign: 'Đồng Ý & Ký',
      signFailed: 'Không thể gửi thỏa thuận',
      signedSuccess: 'Đã ký thỏa thuận thành công',
      subUserBlockedTitle: 'Truy Cập Tài Khoản Đang Chờ',
      subUserBlockedBody: 'Người giám hộ của bạn phải chấp nhận từ bỏ trách nhiệm của người giám hộ trước khi bạn có thể sử dụng ứng dụng. Vui lòng yêu cầu họ đăng nhập và hoàn thành các tài liệu cần thiết.',
      adultSubUserInviteTitle: 'Thiết Lập Tài Khoản Người Lớn Phụ Thuộc',
      adultSubUserInviteBody: '{{name}} từ 18 tuổi trở lên và phải tự ký các tài liệu và từ bỏ trách nhiệm pháp lý của mình. Với tư cách là người giám hộ, bạn không thể ký các tài liệu pháp lý thay mặt cho một người lớn. Vui lòng mời {{name}} thiết lập tài khoản riêng để họ có thể đăng nhập và hoàn thành các từ bỏ trách nhiệm của mình.',
      adultSubUserStatusInvited: 'Trạng thái: Đã gửi lời mời đến {{email}}',
      adultSubUserStatusPending: 'Trạng thái: Đang chờ thiết lập',
      adultSubUserInstructionsInvited: 'Đang chờ đăng ký và hoàn thành từ bỏ trách nhiệm. Họ có thể quét mã QR bên dưới hoặc sử dụng liên kết mời để đăng ký và ký.',
      adultSubUserInstructionsPending: 'Vui lòng chia sẻ liên kết mời hoặc mã QR bên dưới để cho phép họ đăng ký và ký các từ bỏ trách nhiệm của riêng mình.',
      profileSection: 'Tài Liệu Pháp Lý',
      viewPdf: 'Xem PDF',
      downloadCertificate: 'Tải Chứng Nhận',
      reAgree: 'Ký Lại',
      agreed: 'Đã Đồng Ý',
      updateRequired: 'Cần Cập Nhật',
      docs: {
        athlete_waiver: { title: 'Từ Bỏ Trách Nhiệm Vận Động Viên' },
        athlete_code_of_conduct: { title: 'Quy Tắc Ứng Xử Vận Động Viên' },
        guardian_waiver: { title: 'Từ Bỏ Trách Nhiệm Người Giám Hộ' },
        guardian_code_of_conduct: { title: 'Quy Tắc Ứng Xử Người Giám Hộ' },
      },
      affirmations: {
        athlete: {
          read_and_understand: 'Tôi đã đọc và hiểu tài liệu này',
          legally_bound: 'Tôi đồng ý bị ràng buộc pháp lý bởi tài liệu này',
          voluntary_assumption_of_risk: 'Tôi thừa nhận việc tự nguyện chấp nhận rủi ro',
          abide_by_rules: 'Tôi đồng ý tuân thủ các quy tắc và tiêu chuẩn ứng xử',
        },
        guardian: {
          confirm_guardianship: 'Tôi xác nhận rằng tôi là cha mẹ hoặc người giám hộ hợp pháp của trẻ vị thành niên được đặt tên dưới đây',
          read_and_understand: 'Tôi đã đọc, hiểu và đồng ý bị ràng buộc pháp lý bởi tài liệu này',
          voluntary_assumption_of_risk: 'Tôi thừa nhận việc tự nguyện chấp nhận rủi ro và từ bỏ trách nhiệm thay mặt cho con tôi',
          data_consent: 'Tôi đồng ý cho CBJJ Saigon thu thập và xử lý dữ liệu cá nhân của con tôi (bao gồm tên, ngày sinh và tiến độ đào tạo) cho mục đích thành viên và chứng nhận đai như được mô tả trong [[PP_LINK]].',
          data_consent_over_7: 'Tôi và con tôi đã đọc và đồng ý với việc thu thập dữ liệu cá nhân và tiến độ đào tạo như được mô tả trong [[PP_LINK]].',
          abide_by_rules: 'Tôi đồng ý tuân thủ các quy tắc và tiêu chuẩn ứng xử thay mặt cho con tôi',
        },
      },
    },
    minorNameLabel: 'Họ và Tên Đầy Đủ Của Trẻ Vị Thành Niên',
    guardianNameLabel: 'Họ và Tên Đầy Đủ Của Người Giám Hộ',
    minorNameRequired: 'Vui lòng nhập họ và tên đầy đủ của trẻ vị thành niên',
    loadError: 'Không thể tải tài liệu. Vui lòng kiểm tra kết nối và thử lại.',
    allSignedTitle: 'Hoàn Tất! 🎉',
    allSignedMessage: 'Tất cả tài liệu cần thiết đã được ký. Hội viên của bạn đã kích hoạt và bạn đã sẵn sàng sử dụng ứng dụng cũng như điểm danh tham gia các lớp học.',
    allSignedButton: 'Vào Ứng Dụng',
  },

  // ─── Account Deletion ─────────────────────────────────────────────
  accountDeletion: {
    title: 'Xóa Tài Khoản',
    link: 'Xóa Tài Khoản',
    loggedOutIntro: 'Bạn có quyền xóa tài khoản CBJJ Saigon và dữ liệu cá nhân liên quan. Để tiếp tục, bạn cần đăng nhập để xác minh danh tính.',
    loggedInIntro: 'Bạn có thể xóa vĩnh viễn tài khoản CBJJ Saigon và tất cả dữ liệu cá nhân liên quan từ màn hình này. Hành động này là ngay lập tức và không thể hoàn tác.',
    planLossWarning: 'Cảnh báo: Việc xóa tài khoản sẽ chấm dứt gói hội viên của bạn ngay lập tức. Nếu bạn còn thời gian trong gói hiện tại, sẽ không được hoàn tiền.',
    stepsTitle: 'Cách Xóa Tài Khoản',
    loggedOutStep1: 'Đăng nhập vào tài khoản CBJJ Saigon của bạn bằng nút bên dưới.',
    loggedOutStep2: 'Sau khi đăng nhập, quay lại màn hình này và làm theo các bước xác nhận để xóa tài khoản.',
    loggedOutStep3: 'Tài khoản và dữ liệu cá nhân của bạn sẽ bị xóa vĩnh viễn ngay lập tức khi xác nhận.',
    loggedInStep1: 'Xem thông tin xóa và lưu giữ dữ liệu bên trên.',
    loggedInStep2: 'Nhấn "Xóa Tài Khoản" và xác nhận bằng cách nhập địa chỉ email của bạn. Tài khoản của bạn sẽ bị xóa ngay lập tức.',
    dataTitle: 'Xóa Dữ Liệu & Thời Hạn Lưu Giữ',
    dataDeleted: 'Dữ liệu sau sẽ bị xóa vĩnh viễn: thông tin hồ sơ (họ tên, email, ngày sinh, cân nặng, chiều cao), tiến độ đào tạo và hồ sơ đai, lịch sử điểm danh, và liên kết gia đình/người giám hộ.',
    subUsersDeleted: 'Người dùng phụ thuộc (trẻ em hoặc thành viên gia đình không có tài khoản đăng nhập riêng) được liên kết với tài khoản của bạn cũng sẽ bị xóa, cùng với dữ liệu của họ.',
    subUsersRetained: 'Người dùng phụ đã đăng ký người lớn có email đăng nhập riêng sẽ KHÔNG bị xóa — họ chỉ được hủy liên kết với tài khoản của bạn và giữ lại dữ liệu của riêng họ.',
    dataRetained: 'Dữ liệu sau sẽ được lưu giữ theo yêu cầu pháp luật hoặc mục đích kinh doanh hợp pháp: hồ sơ thanh toán (kèm thông tin hóa đơn), thỏa thuận pháp lý đã ký, thống kê tổng hợp ẩn danh, hồ sơ giao dịch tài chính theo luật thuế Việt Nam, và bản sao thỏa thuận pháp lý được lưu giữ trong thời hạn hiệu lực pháp lý.',
    retentionPeriod: 'Hồ sơ tài chính và pháp lý được lưu giữ tối đa 7 năm kể từ ngày giao dịch hoặc thỏa thuận, sau đó sẽ bị xóa vĩnh viễn.',
    signInButton: 'Đăng Nhập',
    requestButton: 'Xóa Tài Khoản',
    confirmWarning: 'Hành động này sẽ xóa vĩnh viễn tài khoản của bạn ngay lập tức. Bạn sẽ mất quyền truy cập gói hội viên mà không được hoàn tiền. Để xác nhận, vui lòng nhập địa chỉ email tài khoản của bạn bên dưới.',
    yourEmail: 'Email tài khoản của bạn',
    emailConfirmLabel: 'Nhập email để xác nhận',
    emailMismatch: 'Email bạn nhập không khớp với email tài khoản của bạn.',
    confirmButton: 'Xóa Tài Khoản Của Tôi',
    requestFailed: 'Không thể xóa tài khoản. Vui lòng thử lại sau.',
    successTitle: 'Tài Khoản Đã Xóa',
    successBody: 'Tài khoản của bạn đã bị xóa vĩnh viễn. Bạn đã được đăng xuất.',
    cancel: 'Hủy',
    goToLogin: 'Đăng Nhập',
  },
};

export default vi;
